import styled, { css } from 'styled-components'

import { color, media, radius, spacing, typography } from '../../themes'
import { Link } from '../Link/index'

export const Container = styled.aside`
  visibility: ${({ isVisible }: { isVisible: boolean }) =>
    isVisible ? 'visible' : 'hidden'};
`

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.2s ease;
  opacity: ${({ open }: { open: boolean }) => (open ? '1' : '0')};
  z-index: 40;
`

export const Pane = {
  Container: styled.div`
    position: fixed;
    right: 0;
    top: 0;
    width: calc(100% - 40px);
    height: 100vh;
    overflow-y: auto;
    z-index: 50;
    display: flex;
    flex-direction: column;
    color: ${color('white')};
    transition: transform 0.2s ease;
    transform: ${({ open }: { open: boolean }) =>
      open ? 'translate(0, 0)' : 'translate(100%, 0)'};
    background: rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(20px);

    ${media.pc} {
      width: 392px;
    }
  `,
  Inner: styled.div``,
  ButtonContainer: styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `,
  CloseButton: styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    width: 56px;
    background: none;
    cursor: pointer;
    color: ${color('white')};
  `,
  Content: styled.div`
    padding: ${spacing(0, 4, 40)};

    ${media.pc} {
      padding: ${spacing(0, 7, 40)};
    }
  `,
}

export interface SectionProps {
  divider?: boolean
  mt?: number
}

export const Section = styled.div<SectionProps>`
  ${typography('body2')};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: ${({ theme, mt }) => theme.spacing(mt ?? 4)};

  ${({ divider }) =>
    divider &&
    css`
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      padding-top: ${spacing(4)};
    `}
`

export const Heading = styled.h3`
  color: rgba(255, 255, 255, 0.5);
`

export interface ListProps {
  justifyContent?: 'flex-start' | 'center' | 'flex-end'
  mt?: number
}

export const List = styled.ul<ListProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
  width: 100%;
  margin-top: ${({ mt = 0, theme }) => theme.spacing(mt)};
`

export interface ListItemProps {
  ml?: number
  mt?: number
  fullWidth?: boolean
  isLink?: boolean
}

export const ListItem = styled.li<ListItemProps>`
  margin-left: ${({ ml = 0, theme }) => theme.spacing(ml)};
  margin-top: ${({ mt = 0, theme }) => theme.spacing(mt)};
  width: ${({ fullWidth = false }) => (fullWidth ? '100%' : 'auto')};

  ${({ isLink }) =>
    isLink &&
    css`
      & > a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        text-decoration: none;
        color: ${color('white')};
      }
    `}
`

export const CircleIconButton = styled(Link)`
  color: ${color('white')};
  border: 1px solid ${color('white')};
  border-radius: ${radius('full')};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;

  &:hover {
    opacity: 0.75;
  }
`
